export const UppercaseDirective = {
  bind (el) {
    el.addEventListener('input', changeCase)
  },
  unbind (el) {
    el.removeEventListener('input', changeCase)
  }
}

const changeCase = (event) => {
  event.target.value = event.target.value.toUpperCase()
}
